module.exports = "pegasus/assets/custom-2-google.png";